import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-oshveda-primary text-oshveda-bg mt-20" data-testid="site-footer">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-14 h-14 rounded-full bg-oshveda-bg flex items-center justify-center p-1.5">
              <img src="/oshveda-logo.png" alt="Oshveda Naturals" className="w-full h-full object-contain" />
            </div>
            <div>
              <div className="font-serif text-2xl">Oshveda Naturals</div>
              <div className="label-eyebrow !text-oshveda-bg/60">Ayurveda. Authentic. Always.</div>
            </div>
          </div>
          <p className="font-serif italic text-xl text-balance text-oshveda-bg/85 leading-snug max-w-md">
            Rooted in the wisdom of ancient Ayurveda. Crafted for the modern seeker.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="label-eyebrow !text-oshveda-bg/60 mb-4">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/shop" className="hover:text-oshveda-accent transition-colors">Shop all</Link></li>
            <li><Link to="/about" className="hover:text-oshveda-accent transition-colors">Our Story</Link></li>
            <li><Link to="/contact" className="hover:text-oshveda-accent transition-colors">Contact</Link></li>
            <li><Link to="/admin/login" className="hover:text-oshveda-accent transition-colors">Admin</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="label-eyebrow !text-oshveda-bg/60 mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3"><Phone size={14} /> +91 70150 96120</li>
            <li className="flex items-center gap-3"><Mail size={14} /> hello@oshvedanaturals.store</li>
            <li className="flex items-start gap-3"><MapPin size={14} className="mt-1" /> India</li>
          </ul>
          <div className="flex items-center gap-4 mt-6">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-oshveda-bg/30 flex items-center justify-center hover:bg-oshveda-bg hover:text-oshveda-primary transition-colors" data-testid="social-instagram">
              <Instagram size={16} />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-oshveda-bg/30 flex items-center justify-center hover:bg-oshveda-bg hover:text-oshveda-primary transition-colors" data-testid="social-facebook">
              <Facebook size={16} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-oshveda-bg/15">
        <div className="container-x py-6 text-xs text-oshveda-bg/60 flex flex-col sm:flex-row items-center justify-between gap-2">
          <div>© {new Date().getFullYear()} Oshveda Naturals. All rights reserved.</div>
          <div className="tracking-widest uppercase">oshvedanaturals.store</div>
        </div>
      </div>
    </footer>
  );
}
